import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { log } from 'utils';
import { errorMsg } from 'utils';

export const SETTINGS_FETCH_DATA_INIT = createAction(
  'SETTINGS_FETCH_DATA_INIT'
);
export const SETTINGS_FETCH_DATA_SUCCESS = createAction(
  'SETTINGS_FETCH_DATA_SUCCESS'
);
export const SETTINGS_FETCH_DATA_FAIL = createAction(
  'SETTINGS_FETCH_DATA_FAIL'
);

export const SETTINGS_CLEAR_DATA = createAction('SETTINGS_CLEAR_DATA');

export const SETTINGS_MODIFY_INIT = createAction('SETTINGS_MODIFY_INIT');
export const SETTINGS_MODIFY_SUCCESS = createAction('SETTINGS_MODIFY_SUCCESS');
export const SETTINGS_MODIFY_FAIL = createAction('SETTINGS_MODIFY_FAIL');

export const SETTINGS_CLEAN_UP = createAction('SETTINGS_CLEAN_UP');

export const SETTINGS_CLEAR_DATA_LOGOUT = createAction(
  'SETTINGS_CLEAR_DATA_LOGOUT'
);

export const fetchSettings = ({ siteId, screenId }) => {
  return async (dispatch) => {
    dispatch(SETTINGS_FETCH_DATA_INIT());
    if (siteId) {
      let settings;
      try {
        settings = await Axios.get(`${url}/settings/list`, {
          params: {
            siteId,
            screenId,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
        log(settings, '<<< infor cat');
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(SETTINGS_FETCH_DATA_FAIL({ error }));
      }

      settings = settings.data.data;

      return dispatch(
        SETTINGS_FETCH_DATA_SUCCESS({
          settings,
        })
      );
    }
  };
};

export const connectSocket = async (screenId) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/connect`,
        {
          screenId: screenId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const changeVolume = async (screenId, value) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/volume`,
        {
          screenId: screenId,
          value: value,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const changeMute = async (screenId, value) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/volume`,
        {
          screenId: screenId,
          value: value,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const changeDisplay = async (screenId, data) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/display`,
        {
          screenId: screenId,
          data: data,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const screenShot = async (screenId) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/screenshot`,
        {
          screenId: screenId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const installApplication = async (screenId, downloadUrl) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/install`,
        {
          screenId: screenId,
          url: downloadUrl,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
      toastr.success('', 'Application has been installed successfully');
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const restartScreen = async (screenId) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/restart`,
        {
          screenId: screenId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
      toastr.success('', 'Screen has restarted successfully');
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const forceUpdate = async (screenId) => {
  if (screenId) {
    try {
      const res = await Axios.post(
        `${url}/socket/update`,
        {
          screenId: screenId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
      log(res);
      toastr.success('', 'Screen has updated successfully');
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
    }
  }
};

export const forceUpdateScreens = async (screenIds = []) => {
  if (!screenIds.length) {
    return;
  }

  const results = await Promise.all(
    screenIds.map(async (screenId) => {
      try {
        const res = await Axios.post(
          `${url}/socket/update`,
          {
            screenId,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
        log(res);
        return { screenId, success: true };
      } catch (error) {
        log(error);
        return { screenId, success: false, error };
      }
    })
  );

  const failed = results.filter((result) => !result.success);

  if (failed.length) {
    toastr.error(
      '',
      `Failed to update ${failed.length} of ${screenIds.length} screen(s)`
    );
  }

  const succeeded = screenIds.length - failed.length;
  if (succeeded) {
    toastr.success('', `${succeeded} screen(s) have updated successfully`);
  }

  return results;
};

export const clearSettingsData = () => {
  return (dispatch) => {
    dispatch(SETTINGS_CLEAR_DATA());
  };
};

export const clearSettingsDataLogout = () => {
  return (dispatch) => {
    dispatch(SETTINGS_CLEAR_DATA_LOGOUT());
  };
};

export const modifysettings = ({
  siteId,
  screenId,
  settings,
  modifiedAt,
  modifiedBy,
}) => {
  return async (dispatch) => {
    dispatch(SETTINGS_MODIFY_INIT());

    const settingsData = {
      siteId,
      screenId,
      settings,
      modifiedAt,
      modifiedBy,
    };

    const updatesettingsDbTask = Axios.post(
      `${url}/settings/edit`,
      settingsData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );

    try {
      await Promise.all([updatesettingsDbTask]);
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);

      return dispatch(
        SETTINGS_MODIFY_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'Settings updated successfully');

    return dispatch(
      SETTINGS_MODIFY_SUCCESS({
        settings: settingsData,
      })
    );
  };
};

export const settingsCleanUp = () => (dispatch) =>
  dispatch(SETTINGS_CLEAN_UP());


/* Bulk fan-out helpers used by the Screens page multi-select toolbar. Unlike
 * forceUpdateScreens these hit the server's bulk endpoints, so a single request
 * covers the whole selection and the response reports which screens acked. */

const bulkAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
});

export const bulkUpdate = (screenIds) => {
  return async () => {
    if (!screenIds || screenIds.length === 0) return { online: [], offline: [] };

    try {
      const res = await Axios.post(
        `${url}/socket/bulk-update`,
        { screenIds },
        { headers: bulkAuthHeaders() }
      );

      log(res);

      const offline = res.data?.offline || [];
      if (offline.length) {
        toastr.warning(
          '',
          `${res.data.online.length} updated, ${offline.length} offline`
        );
      } else {
        toastr.success('', `${screenIds.length} screen(s) updated successfully`);
      }

      return res.data;
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
      return { online: [], offline: [] };
    }
  };
};

export const bulkRestart = (screenIds) => {
  return async () => {
    if (!screenIds || screenIds.length === 0) return null;

    try {
      const res = await Axios.post(
        `${url}/socket/bulk-restart`,
        { screenIds },
        { headers: bulkAuthHeaders() }
      );

      log(res);
      toastr.success('', `${screenIds.length} screen(s) restarted successfully`);
      return res.data;
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
      return null;
    }
  };
};

export const bulkVolume = (screenIds, volume) => {
  return async () => {
    if (!screenIds || screenIds.length === 0) return null;

    try {
      const res = await Axios.post(
        `${url}/socket/bulk-volume`,
        { screenIds, volume },
        { headers: bulkAuthHeaders() }
      );

      log(res);
      toastr.success(
        '',
        `${screenIds.length} screen(s) volume updated successfully`
      );
      return res.data;
    } catch (error) {
      log(error);
      toastr.error('', `${error}`);
      return null;
    }
  };
};
